import { createEnv } from '@t3-oss/env-core';
import { z } from 'zod';

export const env = createEnv({
  clientPrefix: 'VITE_',
  client: {
    VITE_API_DOMAIN: z.string().url(),
    VITE_CONSOLE_DOMAIN: z.string().url(),
    VITE_CLOUDINARY_CLOUD_NAME: z.string(),
    VITE_SUPERTOKENS_TENANT_ID: z.string(),
    VITE_SENTRY_DSN: z.string().url().optional(),
    VITE_SENTRY_ENVIRONMENT: z.string().optional(),
    VITE_SENTRY_RELEASE: z.string().optional(),
  },
  runtimeEnv: import.meta.env,
  emptyStringAsUndefined: true,
});
